"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireWildcard(require("immutable"));

var _reactDnd = require("react-dnd");

var _reactDndHtml5Backend = require("react-dnd-html5-backend");

var _reactRedux = require("react-redux");

var _Files = require("FileManagerCore/actions/Files");

var _tempFileId = _interopRequireDefault(require("FileManagerCore/utils/tempFileId"));

var _ImageUploadZone = _interopRequireDefault(require("FileManagerLib/components/ImageUploadZone"));

var _Constants = require("FileManagerLib/Constants");

var _Actions = require("FileManagerLib/actions/Actions");

var _file = require("FileManagerCore/utils/file");

var _Filter = require("FileManagerLib/selectors/Filter");

var _fileFiltering = require("FileManagerLib/utils/fileFiltering");

var _UploadingFiles = require("FileManagerCore/selectors/UploadingFiles");

var _DropZoneErrorTypes = _interopRequireDefault(require("FileManagerLib/enums/DropZoneErrorTypes"));

var _FileDropZoneUploadError = _interopRequireDefault(require("FileManagerLib/components/errors/FileDropZoneUploadError"));

var fileTarget = {
  drop: function drop(props, monitor, component) {
    component.maybeResetErrorState();
    var onDropFile = props.onDropFile,
        onChange = props.onChange,
        filter = props.filter;
    var files = monitor.getItem().files;

    if (!files || files.length === 0) {
      return;
    }

    var file = files[0];
    var tempId = (0, _tempFileId.default)();

    if (!(0, _file.isImage)(file)) {
      component.setFileNotAnImageError(file.name);
      return;
    }

    if (!(0, _fileFiltering.isExtensionFromRawFileSupported)(file, filter)) {
      component.setInvalidFileExtensionError((0, _fileFiltering.getFileExtensionFromRawFile)(file));
      return;
    }

    component.setState({
      tempId: tempId
    });
    onDropFile(file, {
      tempId: tempId
    }).then(function (image) {
      component.setState({
        tempId: null
      });

      if (image) {
        var url = image.get('url');
        onChange(url, image);
      }
    }).done();
  }
};

var ImageUploadWithAsyncFilePicker =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ImageUploadWithAsyncFilePicker, _Component);

  function ImageUploadWithAsyncFilePicker(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ImageUploadWithAsyncFilePicker);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ImageUploadWithAsyncFilePicker).call(this, props));
    _this.state = {
      drawerOpen: false,
      tempId: null,
      error: null
    };
    _this.handleBrowse = _this.handleBrowse.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleClose = _this.handleClose.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSelect = _this.handleSelect.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleRemove = _this.handleRemove.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleUpload = _this.handleUpload.bind((0, _assertThisInitialized2.default)(_this));
    _this.maybeResetErrorState = _this.maybeResetErrorState.bind((0, _assertThisInitialized2.default)(_this));
    _this.setInvalidFileExtensionError = _this.setInvalidFileExtensionError.bind((0, _assertThisInitialized2.default)(_this));
    _this.setFileNotAnImageError = _this.setFileNotAnImageError.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ImageUploadWithAsyncFilePicker, [{
    key: "setInvalidFileExtensionError",
    value: function setInvalidFileExtensionError(fileExtension) {
      this.setState({
        error: {
          type: _DropZoneErrorTypes.default.INVALID_FILE_EXTENSION,
          fileExtension: fileExtension,
          filter: this.props.filter
        }
      });
    }
  }, {
    key: "setFileNotAnImageError",
    value: function setFileNotAnImageError(filename) {
      this.setState({
        error: {
          type: _DropZoneErrorTypes.default.NOT_AN_IMAGE,
          filename: filename
        }
      });
    }
  }, {
    key: "getUrl",
    value: function getUrl() {
      var imageUrl = this.props.imageUrl;
      var tempId = this.state.tempId;
      var tempFile = this.getTempFile();

      if (!tempId) {
        return imageUrl;
      }

      if (!tempFile) {
        // TODO: switch to get the file from the uploadedFiles slice of state
        // when it is created to avoid a flicker
        return null;
      }

      return tempFile.get('tempUrl');
    }
  }, {
    key: "getTempFile",
    value: function getTempFile() {
      var uploadingFiles = this.props.uploadingFiles;
      var tempId = this.state.tempId;

      if (!tempId || !uploadingFiles.has(tempId)) {
        return null;
      }

      return uploadingFiles.get(tempId);
    }
  }, {
    key: "handleBrowse",
    value: function handleBrowse() {
      this.setState({
        drawerOpen: true
      });
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.setState({
        drawerOpen: false
      });
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(image) {
      this.maybeResetErrorState();
      var onChange = this.props.onChange;
      onChange(image.get('url'), image);
      this.setState({
        drawerOpen: false
      });
    }
  }, {
    key: "handleRemove",
    value: function handleRemove() {
      var onChange = this.props.onChange;
      onChange(null);
    }
  }, {
    key: "handleUpload",
    value: function handleUpload(files) {
      var _this2 = this;

      this.maybeResetErrorState();
      var _this$props = this.props,
          onUploadFile = _this$props.onUploadFile,
          onChange = _this$props.onChange,
          filter = _this$props.filter;

      if (!files || files.length === 0) {
        return;
      }

      var file = files[0];
      var tempId = (0, _tempFileId.default)();

      if (!(0, _file.isImage)(file)) {
        this.setFileNotAnImageError(file.name);
        return;
      }

      if (!(0, _fileFiltering.isExtensionFromRawFileSupported)(file, filter)) {
        this.setInvalidFileExtensionError((0, _fileFiltering.getFileExtensionFromRawFile)(file));
        return;
      }

      this.setState({
        tempId: tempId
      });
      onUploadFile(file, {
        tempId: tempId
      }).then(function (image) {
        _this2.setState({
          tempId: null
        });

        if (image) {
          var url = image.get('url');
          onChange(url, image);
        }
      }).done();
    }
  }, {
    key: "maybeResetErrorState",
    value: function maybeResetErrorState() {
      if (this.state.error) {
        this.setState({
          error: null
        });
      }
    }
  }, {
    key: "renderPicker",
    value: function renderPicker() {
      var _this$props2 = this.props,
          pickerType = _this$props2.pickerType,
          renderFilePicker = _this$props2.renderFilePicker;
      return renderFilePicker({
        pickerType: pickerType,
        onClose: this.handleClose,
        onSelect: this.handleSelect
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          drawerOpen = _this$state.drawerOpen,
          error = _this$state.error;
      var _this$props3 = this.props,
          children = _this$props3.children,
          onChange = _this$props3.onChange,
          iconName = _this$props3.iconName,
          iconSize = _this$props3.iconSize,
          size = _this$props3.size,
          connectDropTarget = _this$props3.connectDropTarget,
          isOver = _this$props3.isOver;
      var tempFile = this.getTempFile();
      return connectDropTarget(_react.default.createElement("div", null, _react.default.createElement(_ImageUploadZone.default, {
        iconName: iconName,
        iconSize: iconSize,
        size: size,
        imageUrl: this.getUrl(),
        progress: tempFile && tempFile.get('progress'),
        onChange: onChange,
        onBrowse: this.handleBrowse,
        onRemove: this.handleRemove,
        onUpload: this.handleUpload,
        showBrowse: true,
        isOver: isOver,
        error: error && _react.default.createElement(_FileDropZoneUploadError.default, error)
      }, children), drawerOpen && this.renderPicker()));
    }
  }]);
  return ImageUploadWithAsyncFilePicker;
}(_react.Component);

ImageUploadWithAsyncFilePicker.propTypes = {
  children: _react.PropTypes.node,
  iconName: _react.PropTypes.string,
  iconSize: _react.PropTypes.string,
  size: _react.PropTypes.string,
  pickerType: _react.PropTypes.oneOf(Object.keys(_Constants.PickerTypes)).isRequired,
  imageUrl: _react.PropTypes.string,
  uploadingFiles: _react.PropTypes.instanceOf(_immutable.default.OrderedMap),
  isOver: _react.PropTypes.bool.isRequired,
  onChange: _react.PropTypes.func.isRequired,
  onUploadFile: _react.PropTypes.func.isRequired,
  renderFilePicker: _react.PropTypes.func.isRequired,
  connectDropTarget: _react.PropTypes.func.isRequired,
  filter: _react.PropTypes.instanceOf(_immutable.Map).isRequired
};
var WithDropTarget = (0, _reactDnd.DropTarget)(_reactDndHtml5Backend.NativeTypes.FILE, fileTarget, function (dragAndDropConnect, monitor) {
  return {
    connectDropTarget: dragAndDropConnect.dropTarget(),
    isOver: monitor.isOver()
  };
})(ImageUploadWithAsyncFilePicker);

var mapStateToProps = function mapStateToProps(state) {
  return {
    uploadingFiles: (0, _UploadingFiles.getUploadingFiles)(state),
    filter: (0, _Filter.getFilter)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onUploadFile: function onUploadFile(file, options) {
      dispatch((0, _Actions.trackInteraction)('Manage Files', 'upload'));
      return dispatch((0, _Files.uploadFile)(file, options));
    },
    onDropFile: function onDropFile(file, options) {
      dispatch((0, _Actions.trackInteraction)('Manage Files', 'drag-and-dropped-file'));
      return dispatch((0, _Files.uploadFile)(file, options));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WithDropTarget);

exports.default = _default;
module.exports = exports.default;